const points = (state = [], action) => {
    switch (action.type) {
      case 'UPDATE_POINTS':
        return action.points || [];
      default:
        return state;
    }
  };
  export default points;
  